var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.unscopables` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.unscopables
defineWellKnownSymbol('unscopables');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.symbol.unscopables.js
// module id = 436
// module chunks = 0